// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.floating-icons[data-v-6de09f6b] {\n    position: fixed;\n    top: 60%;\n    left: 0;\n    transform: translate(-0%, -50%);\n    z-index: 10;\n}\n.amount-card[data-v-6de09f6b] {\n    background-image: linear-gradient(#8b1631, #d62634, #8b1631);\n    border-radius: 20px;\n    padding: 10px 20px;\n    font-size: 20px;\n}\n.rank[data-v-6de09f6b] {\n    position: relative;\n    left: -18%;\n    bottom: -50%;\n    z-index: 100 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
